
import React from 'react';
// import './Phone.css';

const Phone = () => {

  return (
    <div class="chatbot-linkbox-container">
        <a href="tel:720-277-2969">
            <div class="chatbot-linkbox">
                <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 24 24">
                    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.445 17.827c-3.684 1.684-9.401-9.43-5.8-11.308l1.053-.519 1.746 3.409-1.042.513c-1.095.587 1.185 5.04 2.305 4.497l1.032-.505 1.76 3.397-1.054.516z">
                    </path>
                </svg>
            </div>
        </a>
    </div>
  );

}

export default Phone;
